var _defs, _path, _rect, _rect2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.12 25.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".phonea{fill:#05ce7c;}.phoneb{fill:none;}.phonec{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "phonea",
    d: "M12.15,0H2A2,2,0,0,0,0,2H0v22a2,2,0,0,0,2,2H12.15a2,2,0,0,0,2-2h0V2a2,2,0,0,0-2-2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "phoneb",
    x: 1.7,
    y: 3.66,
    width: 10.71,
    height: 17.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "phonec",
    x: 1.44,
    y: 3.4,
    width: 11.24,
    height: 18.42
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "phonec",
    d: "M7.06,22.2a1.23,1.23,0,1,0,1.22,1.22h0A1.22,1.22,0,0,0,7.06,22.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "phonec",
    d: "M5.51,2.35h3.1a.13.13,0,0,0,.16-.1.15.15,0,0,0-.11-.16H5.51a.13.13,0,0,0-.16.11.13.13,0,0,0,.1.15Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f55dc8ee3f800505574fcc14473d134d.svg";
export { ForwardRef as ReactComponent };